import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const SlaIcon = (props: SvgProps) => (
  <Svg
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <Path
      fill={props.color || '#0058AD'}
      d="M9.769 5.885a.752.752 0 1 0-1.504 0V8.89c0 .415.337.752.752.752h3.007a.752.752 0 0 0 0-1.503H9.769V5.885Z"
    />
    <Path
      fill={props.color || '#0058AD'}
      fillRule="evenodd"
      d="M9.017 3.003a6.013 6.013 0 0 0-.75 11.98c.412.052.75.384.75.799 0 .415-.338.755-.75.715a7.518 7.518 0 1 1 8.23-8.23c.04.412-.3.75-.715.75s-.747-.338-.798-.75a6.015 6.015 0 0 0-5.967-5.264Z"
      clipRule="evenodd"
    />
    <Path
      fill={props.color || '#0058AD'}
      d="M12.416 10.778a.6.6 0 0 1 .804.89l-.527.527h1.654a2.153 2.153 0 0 1 0 4.305h-.776a.601.601 0 0 1-.598-.54l-.002-.06.002-.062a.601.601 0 0 1 .598-.54h.776a.952.952 0 0 0 0-1.902h-1.654l.527.527a.6.6 0 0 1-.849.849l-1.552-1.552a.6.6 0 0 1 0-.849l1.552-1.552.045-.041Z"
    />
  </Svg>
);
export default SlaIcon;
